export default __webpack_public_path__ + "static/media/placeholder_chart_vertical_bar.49ba28cb.svg";